import React from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const CustomToolTip = ({ active, payload, label, units }) => {
    if (active) {
        return (
            <div className="custom-tooltip" style={
                { backgroundColor: "white", borderRadius: "3px",
            padding: "10px 10px 15px", boxShadow: "0 1px 2px rgba(0,0,0,.1)"}
            }>
                <p className="label">
                    <strong>Year: </strong>
                    {new Date(label).getFullYear()}
                </p>
                <p className="label">
                    <strong>Annual Average: </strong>
                    {`${payload[0].value.toFixed(2)} ${units}`}
                </p>
                <p className="label" style={{color: "#7303AF"}}>
                    <strong>21-year Average: </strong>
                    {`${payload[1].value.toFixed(2)} ${units}`}
                </p>
            </div>
        );
    } else {
        return null;
    }
};
    


const TimeSeriesPlot = ({ data, ifDecade }) => {
    if (!data || !data.time_series) return null;
    //console.log("Current time right now: ", new Date().getTime())
    //console.log("Data: ", data)
    const { time, weighted_time_series, binomial_filter, units } = data.time_series;

    // Prepare data for Recharts
    const chartData = time.map((t, index) => ({
        date: t, // Assuming 't' is already in a format that Recharts can parse as a date
        weightedTimeSeries: weighted_time_series[index],
        binomialFilter: binomial_filter[index],
    }));

    // Calculate min and max for Y axis
    const allValues = [...weighted_time_series, ...binomial_filter];
    const maxValue = Math.max(...allValues);
    const minValue = Math.min(...allValues);
    // Adjust by ±10%
    const yAxisDomain = [
        Number(minValue - (Math.abs(minValue) * 0.05)),
        Number(maxValue + (Math.abs(maxValue) * 0.05))
    ];
    

    const yearFormatter = (date) => {
        return new Date(date).getFullYear();
    };

    const yAxisFormatter = (value) => {
        return value.toFixed(0) + units;
    };

    const tooltipFormatter = (value) => {
        return `${value.toFixed(2)} ${units}`;
    };


    return (
        <ResponsiveContainer width="100%" height={420}>
            <LineChart
                data={chartData}
                margin={{
                    top: 5,
                    right: 10,
                    left: 10,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date"
                    tickFormatter={yearFormatter}
                    tick={{fontSize: "10px"}}
                    label={{
                        value: 'Year',
                        position: 'bottom',
                        style: {fontSize: '12px'},
                        offset: -8
                    }} />
                <YAxis domain={yAxisDomain}
                    tickFormatter={yAxisFormatter}
                    tick={{fontSize: "12px"}}
                    label={{
                        value: 'Value (' + units + ')',
                        angle: -90,
                        position: 'left',
                        style: {fontSize: '12px', textAnchor: 'middle'},
                    }} />
                <Tooltip formatter={tooltipFormatter} content={<CustomToolTip units={units} />} />
                <Legend verticalAlign="bottom" height={12} wrapperStyle={{position: 'relative', marginTop: '10px'}}/>
                <Line type="monotone" name="Annual Average" dataKey="weightedTimeSeries" stroke="#000000" dot={false} activeDot={{ r: 8 }} strokeWidth={2}/>
                <Line type="monotone" name="21-Year Average" dataKey="binomialFilter" dot={false} activeDot={{ r: 8 }} stroke="#7303AF" strokeDasharray="5 5" strokeWidth={3}/>
            </LineChart>
        </ResponsiveContainer>
    );
};

export default TimeSeriesPlot;